module.exports = __webpack_public_path__ + "img/cashless-payment.312b2bf8.png";